const dashboardtxt = {
    welcome: "Welcome",
    hello: "Hello",
    logout: "Log out",
    thisisyourprivateaccount: "This is your private account, please switch to a full account to get access to events, get the ability to charge ads and more.",
    userdashboard: "User dashboard",
    importevents: "Import events",
    importeventsdescription: "Copy the link to the event - or your event page - and paste it here below. We will scan the page and import your events.",

    howdoesthisallwork: "How does this all work?",
    wanttosignup: "Wanna join up?",
    makesureyourevents: "Make sure your events are in the database, with the right information.",
    itsallfreeexcept: "Access is free, event registration is free. Ads are not and neither is the API service.",
    firstwasnothing: "'til there was you",
    youasyou: "You as an individual, who can play many roles.",
    homebythesea: "Home by the sea.",
    theonethatpaysthebills: "The one that pays the bills. Or is responsible for the events. It can be the band, or the venue, or the promoter, or the municipality. You can have more than one of those, if you are working with more than one artist, or venues, or websites. You can give others access and when the drummer quits you can take him off the list and put the new one on.",
    onemorenight: "One more night",
    fullaccountscan: "Full accounts can  apply for permission to edit events in our event database - or create them. It splits into three; to edit events for a venue, or for an artist, or single events.",
    eventsallover: "Our event information is displayed on websites all over the world, and through our API service.",

    frontpageheadline: "The AI filtered event database",
    uptodateeventinfo: "Up to date event information, ready to be used in your website, app or other services.",
    formedia: "For the media",
    forperformers: "For performers",
    forvenues: "For venues",
    usingscripts: "Using scripts",
    usingAPI: "Using API",

    forvenuestitle: "Keep your events up to date and listed on websites and apps",
    forvenuesslug: "Manage your event information and promote events on participating sites. Help the AI classify your events so they show in the correct lists. Get event listings for your site or have us scrape your site for events.",
    forperformerstitle: "Keep your events up to date and get the word out",
    forperformersslug: "Manage, add or import your event information and promote events on participating sites. Help the AI classify your events so they show in the correct lists.",
    formediatitle: "Add revenue with event listings and self-service ads",
    formediaslug: "We can provide you with AI filtered event listings and a revenue share program for event ads. You provide the space and we provide the listings and ads.",

    dashboard: "Dashboard",
    getstarted: "Get started",
};
export default dashboardtxt;
